$(document).ready(function() {

  // Toggle Nav on Click - Help
  $('.js-help-dropdown, .js-nav-close').click(function(event) {
    event.preventDefault();

    $("#header_search").removeClass("open");
    var reopen = $("#offcanvas-menu").hasClass("cart-dropdown-active") || $("#offcanvas-menu").hasClass("nav-dropdown-active") || $("#offcanvas-menu").hasClass("account-dropdown-active");
    var timeout = reopen ? 300 : 0;
    toggleNav($(this), reopen, "right");
    setTimeout(function() {
      $('#offcanvas-menu').addClass('help-dropdown-active');
      $('#offcanvas-menu').removeClass('nav-dropdown-active').removeClass('cart-dropdown-active').removeClass('account-dropdown-active');
      shiftOffCanvasMenu();
    }, timeout);
});

  // Toggle Nav on Click - Account / User
  $('.js-user-dropdown, .js-nav-close').click(function(event) {
      event.preventDefault();

      $("#header_search").removeClass("open");
      var reopen = $("#offcanvas-menu").hasClass("cart-dropdown-active") || $("#offcanvas-menu").hasClass("nav-dropdown-active") || $("#offcanvas-menu").hasClass("help-dropdown-active");
      var timeout = reopen ? 300 : 0;
      toggleNav($(this), reopen, "right");
      setTimeout(function() {
        $('#offcanvas-menu').addClass('account-dropdown-active');
        $('#offcanvas-menu').removeClass('nav-dropdown-active').removeClass('cart-dropdown-active offcanvas-menu-left').removeClass('help-dropdown-active');
        shiftOffCanvasMenu();
        $('#offcanvas-menu').find(':focusable').first().focus();
      }, timeout);
  });

  $('.js-nav-dropdown:not(.nav-active), .js-nav-close').on('focusout', function(event) {
    if($("#offcanvas-menu").hasClass("offcanvas-menu-right"))
    {
      $('#offcanvas-menu').find(':focusable').first().focus();
    }
    else if($("#offcanvas-menu").hasClass("offcanvas-menu-left"))
    {
      $('#offcanvas-menu').find(':focusable').first().focus();
      $('.push-nav__list').first().addClass('active');  
      }
  })

  // Toggle Nav on Click - Account / User
  // $('.js-user-dropdown-loggedin, .js-nav-close').click(function(event) {
  //   event.preventDefault();

  //   $("#header_search").removeClass("open");
  //   var reopen = $("#offcanvas-menu").hasClass("cart-dropdown-active") || $("#offcanvas-menu").hasClass("nav-dropdown-active") || $("#offcanvas-menu").hasClass("help-dropdown-active");
  //   var timeout = reopen ? 300 : 0;

  //   toggleNav($(this), reopen, "right");

  //   setTimeout(function() {
  //     $('#offcanvas-menu').addClass('account-dropdown-active');
  //     $('#offcanvas-menu').removeClass('nav-dropdown-active').removeClass('cart-dropdown-active offcanvas-menu-left').removeClass('help-dropdown-active');;
  //     shiftOffCanvasMenu();
  //   }, timeout);
    
  //   });

  // Canvas slide in:
  // Toggle Nav on Click - Account / User
  $('.js-cart-dropdown, .js-nav-close').click(function(event) {
        event.preventDefault();
        if($(event.currentTarget.parentElement).hasClass('hideMiniCart')) {
        	return;
        }
        
        $("#header_search").removeClass("open");
        var reopen = $("#offcanvas-menu").hasClass("account-dropdown-active") || $("#offcanvas-menu").hasClass("nav-dropdown-active") || $("#offcanvas-menu").hasClass("help-dropdown-active");
        var timeout = reopen ? 300 : 0;
        toggleNav($(this), reopen, "right");

        setTimeout(function() {
            $('#offcanvas-menu').addClass('cart-dropdown-active');
            $('#offcanvas-menu').removeClass('nav-dropdown-active').removeClass('account-dropdown-active');
            shiftOffCanvasMenu();
            $('#offcanvas-menu').find(':focusable').first().focus();
        }, timeout);
        
    });

  // Toggle Nav on Click - Account / User
  $(document).on("click", ".js-nav-dropdown:not(.nav-active), .js-nav-close", function(event) {

      event.preventDefault();

      $("#header_search").removeClass("open");
      
      toggleNav($(this), false, "left");
      
      $('#offcanvas-menu').addClass('nav-dropdown-active').addClass("offcanvas-menu-left");
      $('#offcanvas-menu').removeClass('account-dropdown-active').removeClass('cart-dropdown-active');
      shiftOffCanvasMenu();
  });
    /** Close navigation overlay on close button click */
    $(".menu-dropdown__close").on("click", function() {
        $('.nav__item .menu-dropdown').css("display","none");
    });

    /** Open navigation overlay on keyup and focus only if search active class not present*/
    $(".nav__item").on('keyup mouseover', (function(){
     if( $("body:not(.search-active)").length){
        $('.nav__item .menu-dropdown').css("display","none");
        $(this).find('.menu-dropdown').css("display","flex");
      }}));
      
    /** Close navigation overlay on focusout from overlay*/
    $(".nav__item").on('mouseout', (function(){
      $('.nav__item .menu-dropdown').css("display","none");
    }));

});

// Canvas slide in:
function toggleNav(toggleElement, reopen, position) {
  if (reopen) {
    if (position == "right") {
      $('#offcanvas-menu').removeClass("offcanvas-menu-left").addClass("offcanvas-menu-right");
    } else {
      $('#offcanvas-menu').removeClass("offcanvas-menu-right").addClass("offcanvas-menu-left");
    }
    $(".js-nav-dropdown").find("[class*='icon--']").removeClass("icon--burger").addClass("icon--cross").attr('title',localText["popup.close.menu"]);
    $('#site-wrapper').removeClass('show-nav');
    $("body").removeClass("modal-open");
    setTimeout(function() {
        $('#site-wrapper').addClass('show-nav');
        $("body").addClass("modal-open");
    }, 300);
  }
  else if ($('#site-wrapper').hasClass('show-nav') || $('#site-wrapper').hasClass('show-search')) {
    $(".js-nav-dropdown").find("[class*='icon--']").addClass("icon--burger").removeClass("icon--cross").attr('title',localText["text.menu"]);
    $('#site-wrapper').removeClass('show-nav').removeClass("show-search");
    $("body").removeClass("modal-open");
      setTimeout(function() {
        $('#offcanvas-menu').removeClass("offcanvas-menu-right offcanvas-menu-left");
      }, 300);
  } else {
    if (position == "right") {
      $('#offcanvas-menu').removeClass("offcanvas-menu-left").addClass("offcanvas-menu-right");
    } else {
      $('#offcanvas-menu').removeClass("offcanvas-menu-right").addClass("offcanvas-menu-left");
    }
    
    setTimeout(function() {
      $(".js-nav-dropdown").find("[class*='icon--']").removeClass("icon--burger").addClass("icon--cross").attr('title',localText["popup.close.menu"]);
      $('#site-wrapper').addClass('show-nav');
      $("body").addClass("modal-open");
    }, 100);
      
  }

  // Close search
  $(".menu-dropdown--search").removeClass("active");
  //$(".search__history").hide();
  //$(".search__results").hide();
}

function shiftOffCanvasMenu(){
    $('#offcanvas-menu').css("top", $('#header').css("height"));
}